var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table-server-side-v-1-widget',{attrs:{"url":_vm.url,"columns":_vm.cColumns,"actions":_vm.cActions,"request-columns-filter-type":"base64"},on:{"clickView":_vm.tableClickView}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }